<div class="titleBox"> <h1 style="text-align: center">Job Types</h1></div>
<div><hr></div>
<br>
<br>
<div style="margin-top: 20px; display: flex; justify-content: end;">
  <span><label>Hide Inactive Jobs</label></span>
  <label class="switch">
    <input type="checkbox" [checked]="activeJobToggle" (click)='filterActiveJobs()' >
    <span class="slider round"></span>
  </label>
  </div>
<button mat-raised-button (click)='addDialog()'> Add New Job Type</button>
      <ngx-table [configuration] = "configuration"  [data]="filterActiveJob$ | async" [columns]="columns" [loadingTemplate] = "loadingTemplate" >


          <ng-template let-row>
            <td>
              <div>
                <button button mat-raised-button color="green" (click)='openDialog(row)'>
                  <fa-icon [icon]="faedit"></fa-icon>
                </button>
              </div>

              <!--
              <div>
                <button mat-button color="warn" (click)="delete(row)">
                  <fa-icon [icon]="fatrash"></fa-icon>
                </button>
              </div>
              -->

              <div>
                <button mat-button color="black" title="Copy Job Type" (click)="copy(row)">
                  <fa-icon [icon]="facopy"></fa-icon>
                </button>
              </div>
          </td>

            <td>
              <div>
                {{row.job_type}}
                <span *ngIf="row.inactivejobtype" title="Inactive job type"><svg style="width: 1.25em;
    color: RED;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
</svg>
</span>
              </div>
            </td>

             <td>
              <div>
                {{row.certsreqd}}
              </div>
            </td>

           <td>
              <div>
                {{row.category}}
              </div>
            </td>

          </ng-template>
        </ngx-table>






<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>
    </div>
  </td>
</ng-template>



